import { customToast } from "@/components/Common/Toast";
import { Goal } from "@/types/goals";

export const useGoalValidation = () => {
  const validateAndProcessGoals = async (
    goals: Goal[],
    error: string | null,
    processCallback: (validGoals: Goal[]) => Promise<boolean>,
  ) => {
    try {
      if (error) {
        customToast("Unable to continue", "error");
        return false;
      }

      const isValid = goals.every(
        (goal) => goal.purpose && goal.amount && goal.amount > 0 && goal.year,
      );

      if (!isValid) {
        const hasEmptyFields = goals.some(
          (goal) => !goal.purpose || !goal.year,
        );
        const hasZeroAmount = goals.some((goal) => goal.amount <= 0);

        if (hasZeroAmount) {
          customToast(
            "Goal amount must be greater than $0 for each beneficiary",
            "error",
          );
        } else if (hasEmptyFields) {
          customToast(
            "Please fill out all fields for each beneficiary",
            "error",
          );
        } else {
          customToast(
            "Please fill out all fields for each beneficiary",
            "error",
          );
        }
        return false;
      }

      return await processCallback(goals);
    } catch {
      customToast("Error validating goals", "error");
      return false;
    }
  };

  return {
    validateAndProcessGoals,
  };
};
